import { getSubdomain } from "../components/Config/StylesheetInjector"
import {
  EBAY,
  CARVANA,
  ALLSTATE,
  PAYLINK,
  USAA,
  CARADVISE,
  UBER_CANADA,
  UBER,
  DASHERDIRECT,
  INSTACART
} from "../constants/affiliations"

export function hidePartnerOffers() {
  return isAllstate() || isCarvana() || isPaylink() || isUsaa() || isUberCanada() || isEbay()
}

export function isDasherDirect() {
  return isAffiliation(DASHERDIRECT)
}

export function isAllstate() {
  return isAffiliation(ALLSTATE)
}

export function isCarvana() {
  return isAffiliation(CARVANA)
}

export function isEbay() {
  return isAffiliation(EBAY)
}

export function isPaylink() {
  return isAffiliation(PAYLINK)
}

export function isUsaa() {
  return isAffiliation(USAA)
}

export function isCaradvise() {
  return isAffiliation(CARADVISE)
}

export function isUberCanada() {
  return isAffiliation(UBER_CANADA)
}

export function isUber() {
  return isAffiliation(UBER)
}

export function isInstacart() {
  return true || isAffiliation(INSTACART)
}

export function isEbayCart(user = {}) {
  const affiliation = user.affiliation || {}
  return isEbay() && affiliation.name && affiliation.name.toLowerCase() === EBAY
}

export function isEbayUser(user = {}) {
  const affiliation = user.affiliation || {}
  return affiliation.name && affiliation.name.toLowerCase() === EBAY
}

export function isUsaaUser(user = {}) {
  const affiliation = user.affiliation || {}
  return affiliation.name && affiliation.name.toLowerCase() === USAA
}

// Determine if we're in the context of a given Affiliation.
function isAffiliation(name) {
  return getSubdomain() === name
}

// Hardcoded (not API-driven) per the uber_canada_membership_pricing Split flag: when it's on,
// every Uber Canada membership screen shows this price instead of the Premium plan's API price.
export const UBER_CANADA_MEMBERSHIP_PRICE = "2.99"

// Stands in for a real "Premium" plan from /api/v4/membership_plans so the Uber Canada upgrade
// flow renders even when that endpoint returns no plans for the account/environment.
export const UBER_CANADA_PLACEHOLDER_PLAN = {
  id: "uber-canada-premium",
  name: "Premium",
  price: UBER_CANADA_MEMBERSHIP_PRICE,
  is_free_trial: false
}

// Blue is CarAdvise's entry Uber-driver tier and gets no maintenance discount, unlike
// Diamond/Platinum/Gold which each get their own fixed percentage off.
const UBER_CANADA_TIER_DISCOUNTS = {
  diamond: 30,
  platinum: 20,
  gold: 10
}

export function getUberCanadaTierDiscount(affiliationName = "") {
  const name = affiliationName.toLowerCase()
  const tier = Object.keys(UBER_CANADA_TIER_DISCOUNTS).find((tierName) => name.includes(tierName))
  return tier ? UBER_CANADA_TIER_DISCOUNTS[tier] : null
}
